export default __webpack_public_path__ + "static/neko_coffee_sosogu_nya-a51ddae444ed4c4b946b45b58bdea1da.png";